import { useMemo } from 'react';
import useFeatures from '~/client/hooks/feature/useFeatures';

const useLanguageFeatureFlags = () => {
  const featureFlags = useFeatures();

  const languageFeatureFlags: Partial<Record<LanguageCode, boolean>> = useMemo(
    () => ({
      ar: featureFlags['isArabianEnabled'],
      pt: featureFlags['isPortugueseEnabled'],
      tr: featureFlags['isTurkishEnabled'],
      fi: featureFlags['isFinnishEnabled'],
      no: featureFlags['isNorwegianEnabled'],
    }),
    [featureFlags],
  );

  return languageFeatureFlags;
};

export default useLanguageFeatureFlags;
